import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import FunctionsData from "../../../Functions/FunctionsData";

export default function StaffVoucherCancelRedemption({open,setOpen, voucher, setLoadingVouchers}) {

    const [accept, setAccept] = React.useState(false);

    function removeRedemption() {
        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/voucher/cancel-redemption/')+voucher.voucher_id,
            {})
            .then(data => {
                console.log(data);
                setLoadingVouchers(true);
                setOpen(false);
            })
            .catch(err => {
                console.log(err);
            })
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>Cancel Redemption</DialogTitle>
            <DialogContent>
                <div style={{padding:'0 20px'}}>
                    <ul>
                        <li>Serial: {voucher.voucher_nr}</li>
                        <li>Name: {voucher.a_name}</li>
                        <li>Animal: {voucher.a_type} {voucher.animal_gender}</li>
                        <li>Redeemed on: {voucher.transaction_date}</li>
                        <li>Surgery on: {voucher.a_date_surgery}</li>
                        <li>Surgery: {voucher.a_type_surgery}</li>
                        <li>Surgery amount: NZD {voucher.a_surgery_amount}</li>
                        <li>Vet: {voucher.supplier_business_name}</li>
                        <li>Campaign: {voucher.campaign_name}</li>
                    </ul>
                </div>

                <div style={{marginTop:20}}>
                    <input type={"checkbox"} onChange={(e) => setAccept(e.target.checked)} /> I understand that this action cannot be undone.
                </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button variant={"contained"} disabled={!accept} onClick={removeRedemption}>Remove redemption</Button>
            </DialogActions>
        </Dialog>
    )
}
